import { IconWrapper } from '../runtime';
export default IconWrapper('h1', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M13.2501 9.2606V14.4528C13.2501 14.7566 13.4964 15.0028 13.8001 15.0028C14.1039 15.0028 14.3501 14.7566 14.3501 14.4528V8.84728C14.3501 8.20825 13.6714 7.79775 13.1055 8.09445L11.5447 8.91262C11.2757 9.05366 11.172 9.38608 11.313 9.65511C11.454 9.92414 11.7864 10.0279 12.0555 9.88687L13.2501 9.2606Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M1.75 1.75363V14.2497M9.25 1.75363V14.2497M1.75 8.00168H9.25",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});